// Libs
import React, { Component } from 'react'
import _isEmpty from 'lodash/isEmpty'
import _keys from 'lodash/keys'
import _size from 'lodash/size'
import _forEach from 'lodash/forEach'

// Turf
import center from '@turf/center'

// Styles
import { dark } from 'hfty-styles/src/colors'
import commonStyles from './style'

const styles = {
  container: {
    display: 'flex',
    alignItems: 'center',
    marginRight: '30px',
  },
  directionPad: {
    display: 'flex',
    alignItems: 'center',
    flexDirection: 'column',
    width: '40px',
    height: '40px',
    padding: '5px',
    border: 'solid 1.35px',
    borderRadius: '50%',
    borderColor: '#555559',
  },
  leftRightArrowContainer: {
    display: 'flex',
    justifyContent: 'space-between',
  },
  triangleUp: {
    width: '0',
    height: '0',
    cursor: 'pointer',
    marginBottom: '2px',
    borderLeft: '6px solid transparent',
    borderRight: '6px solid transparent',
    borderBottom: `12px solid ${dark()}`,
  },
  triangleDown: {
    width: '0',
    height: '0',
    cursor: 'pointer',
    marginTop: '2px',
    borderLeft: '6px solid transparent',
    borderRight: '6px solid transparent',
    borderTop: `12px solid ${dark()}`,
  },
  triangleRight: {
    width: '0',
    height: '0',
    cursor: 'pointer',
    marginLeft: '10px',
    borderLeft: `12px solid ${dark()}`,
    borderTop: '6px solid transparent',
    borderBottom: '6px solid transparent',
  },
  triangleLeft: {
    width: '0',
    height: '0',
    cursor: 'pointer',
    marginRight: '10px',
    borderRight: `12px solid ${dark()}`,
    borderTop: '6px solid transparent',
    borderBottom: '6px solid transparent',
  },
}

const PRESS_UP = 'PRESS_UP'
const PRESS_DOWN = 'PRESS_DOWN'
const PRESS_RIGHT = 'PRESS_RIGHT'
const PRESS_LEFT = 'PRESS_LEFT'

type Props = {
  operation: Object,
  gridData: Object,
  selectedFeatureIndices: Array<number>,
  onChange: Function
};

class TranslateGrid extends Component {
  props: Props

  constructor (props) {
    super(props)

    this.onPressButton = (direction) => (e) => this.onPress(e, direction)
  }

  onPress (e, direction) {
    e.preventDefault()
    const {
      onChange,
      gridData,
      selectedFeatureIndices,
      operation: {
        model: { gridData: { grid: { transformations: { offset } } } },
      },
    } = this.props

    let longitude = 0
    let latitude = 0

    let features = {}
    let featureIndices = null

    // Check if only one feature, automatically select it
    if (this.props.operation && _isEmpty(selectedFeatureIndices) && _size(gridData) === 1) {
      featureIndices = _keys(gridData)
    } else if (selectedFeatureIndices.length) {
      featureIndices = selectedFeatureIndices
    }

    if (featureIndices) {
      _forEach(featureIndices, (featureIndex) => {
        if (!offset) {
          const { geometry: { coordinates } } = center(
            gridData[featureIndex].squareGrid
          )
          longitude = coordinates[0]
          latitude = coordinates[1]
        } else {
          longitude = offset.longitude
          latitude = offset.latitude
        }

        switch (direction) {
          case PRESS_UP:
            latitude += 0.00005
            break
          case PRESS_DOWN:
            latitude -= 0.00005
            break
          case PRESS_LEFT:
            longitude -= 0.00005
            break
          case PRESS_RIGHT:
            longitude += 0.00005
            break
        }

        features[featureIndex] = {
          ...this.props.operation.model.gridData.grid[featureIndex],
          offset: { longitude, latitude },
        }
      })

      onChange({
        ...this.props.operation,
        model: {
          ...this.props.operation.model,
          gridData: {
            ...this.props.operation.model.gridData,
            grid: {
              ...this.props.operation.model.gridData.grid,
              ...features,
              transformations: {
                ...this.props.operation.model.gridData.grid.transformations,
                offset: { longitude, latitude },
              },
            },
          },
        },
      })
    }
  }

  render () {
    return (
      <div data-test='translate-grid' style={styles.container}>
        <label style={commonStyles.label}>Move:</label>
        <div style={styles.directionPad}>
          <div
            style={styles.triangleUp}
            onClick={this.onPressButton(PRESS_UP)}
          />
          <div style={styles.leftRightArrowContainer}>
            <div
              style={styles.triangleLeft}
              onClick={this.onPressButton(PRESS_LEFT)}
            />
            <div
              style={styles.triangleRight}
              onClick={this.onPressButton(PRESS_RIGHT)}
            />
          </div>
          <div
            style={styles.triangleDown}
            onClick={this.onPressButton(PRESS_DOWN)}
          />
        </div>
      </div>
    )
  }
}

export default TranslateGrid
